import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Chat from './Chat';
import Login from './Login';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:botId" element={<Chat />} />
        <Route path="/" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
